import PropTypes from "prop-types";
import React, { useState } from "react";
import { Container, Card, CardBody } from "reactstrap";

// PrimeReact
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// i18n
import { withTranslation } from "react-i18next";
import ClientMenu from "./detail-menu";

const ClientsTicket = props => {
  document.title = "Admin | Clients Ticket";

  const [expandedRows, setExpandedRows] = useState(null);

  // -------------------- SUPPORT TICKET DATA --------------------
  const tickets = [
    {
      id: 1,
      ticketId: "TCK-1001",
      createDate: "2025-01-05",
      subject: "Unable to access dashboard",
      status: "Open",
      assignedTo: "Support Agent A",
      solvedDate: null,
      description:
        "Client reports they are unable to log in and see dashboard data.",
      responses: [
        {
          by: "Support Agent A",
          date: "2025-01-05",
          message: "We are looking into this issue.",
        },
        {
          by: "Client",
          date: "2025-01-06",
          message: "Issue still persists.",
        },
      ],
    },
    {
      id: 2,
      ticketId: "TCK-1002",
      createDate: "2025-01-10",
      subject: "Invoice download not working",
      status: "Solved",
      assignedTo: "Support Agent B",
      solvedDate: "2025-01-12",
      description:
        "Invoice PDF fails to download from the invoice screen.",
      responses: [
        {
          by: "Support Agent B",
          date: "2025-01-10",
          message: "Bug identified. Fix in progress.",
        },
        {
          by: "Support Agent B",
          date: "2025-01-12",
          message: "Issue resolved. Please retry.",
        },
      ],
    },
  ];

  // -------------------- STATUS TAG --------------------
  const statusTemplate = row => {
    const severity =
      row.status === "Open"
        ? "warning"
        : row.status === "Solved"
        ? "success"
        : "info";

    return <Tag value={row.status} severity={severity} />;
  };

  // -------------------- ROW EXPANSION --------------------
  const rowExpansionTemplate = data => {
    return (
      <div className="p-3">
        <h6 className="mb-2">Ticket Details</h6>
        <p className="mb-3">{data.description}</p>

        <h6>Responses</h6>
        {data.responses.map((res, index) => (
          <div
            key={index}
            className="border rounded p-2 mb-2 bg-light"
          >
            <strong>{res.by}</strong>
            <div className="text-muted small">{res.date}</div>
            <div>{res.message}</div>
          </div>
        ))}
      </div>
    );
  };

  // -------------------- UI --------------------
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Clients")}
            breadcrumbItem={props.t("Support Tickets")}
          />

          <ClientMenu />

          {/* ================= SUPPORT TICKETS ================= */}
          <Card>
            <CardBody>
              <h5 className="mb-3">Support Tickets</h5>

              <DataTable
                value={tickets}
                expandedRows={expandedRows}
                onRowToggle={e => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
                dataKey="id"
                responsiveLayout="scroll"
                emptyMessage="No tickets found"
              >
                <Column expander style={{ width: "3rem" }} />
                <Column field="createDate" header="Create Date" />
                <Column field="ticketId" header="Ticket ID" />
                <Column field="subject" header="Subject" />
                <Column
                  field="status"
                  header="Status"
                  body={statusTemplate}
                />
                <Column field="assignedTo" header="Assigned To" />
                <Column
                  field="solvedDate"
                  header="Solved Date"
                  body={row =>
                    row.solvedDate ? row.solvedDate : "-"
                  }
                />
                <Column
                  header="Action"
                  body={() => (
                    <Button
                      icon="pi pi-eye"
                      className="p-button-text p-button-sm"
                    />
                  )}
                />
              </DataTable>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

ClientsTicket.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(ClientsTicket);
